import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IEidosConfirmationDialogComponentConfig } from '@common/models/eidos-dialog.interface';
import { ModalRef } from '@app/core/services/core-modal.service';

@Component({
  selector: 'eidos-confirmation-dialog',
  styleUrls: [
    'eidos-confirmation-dialog.component.scss'
  ],
  templateUrl: 'eidos-confirmation-dialog.component.html'
})
export class EidosConfirmationDialogComponent implements OnInit, OnDestroy {
  @Input() modalRef!: ModalRef;
  @Input() modalData!: IEidosConfirmationDialogComponentConfig;

  public title: string = "";
  public message: string = "";
  public confirmationLabel: string = "";
  public cancelLabel: string = "";
  public onConfirm?: () => void;
  public onCancel?: () => void;

  constructor() {
  }

  ngOnInit(): void {
    this.title = this.modalData.title;
    this.message = this.modalData.message;
    this.confirmationLabel = this.modalData.confirmationLabel;
    this.cancelLabel = this.modalData.cancelLabel;
    this.onConfirm = this.modalData.onConfirm;
    this.onCancel = this.modalData.onCancel;
  }

  cancel(): void {
    if (this.onCancel) {
      this.onCancel();
    }
    this.modalRef.close(false);
  }

  confirm(): void {
    if (this.onConfirm) {
      this.onConfirm();
    }
    this.modalRef.close(true);
  }

  ngOnDestroy(): void {
  }
}
